import styled from "styled-components"
import {ButtonPrimary} from "ui/base/Button/ButtonStyled"
import {Modal} from "ui/base/modal/Modal"
import {fonts} from "ui/theme/index.js"
import {useNavigate} from "react-router-dom";
import {instructorRoute} from "pages/instructor/instructor.routes";

export const NoPayoutMethod = ({show, handleClose}) => {
    const navigate = useNavigate()


    return (
        <Modal show={show} handleClose={handleClose} minHeight={200} maxWidth={400}>
            <Content>
                <Title>Add a payout method</Title>
                <Text>
                    Before accepting the class, you will need to add a payout method for us to process the payment
                    after the class.
                </Text>
                <ButtonPrimary onClick={() => {
                    navigate(instructorRoute.settings, {state: {tab: 'paymentMethod'}})
                    handleClose()
                }}>
                    Add payout method
                </ButtonPrimary>
            </Content>
        </Modal>
    )
}

const Content = styled.div`
    font-family: var(--font-secondary);
    flex-direction: column;
    padding: 1rem;
    display: flex;
    gap: 1rem;
`

const Title = styled.div`
    font-size: ${fonts.sizes.big};
    font-weight: bold;
    text-align: center;
`

const Text = styled.div`
    font-size: ${fonts.sizes.regular};
    font-weight: 500;
`
